import React from 'react';
import URLHelpers from './shared/url_helpers';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { withPrefix } from '@reverbdotcom/commons/src/i18n_helpers';
import { RCAlertBox } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { getReturnPolicyDays } from '@reverbdotcom/commons/src/listing_helpers';
import { Item2DescriptionDataFragment } from '@reverbdotcom/commons/src/gql/graphql';
import classNames from 'classnames';

interface ExternalProps {
  listing: Item2DescriptionDataFragment;
  refreshed?: boolean;
}

export function Item2BuyerProtection({ listing, refreshed = false }: ExternalProps) {
  const user = useUser();
  const showBuyerProtectionMessage = listing?.soldAsIs || (user.countryCode === 'US' && getReturnPolicyDays(listing) < 14);

  if (!listing || !showBuyerProtectionMessage) return null;

  const userOutsideUS = !!user.countryCode && user.countryCode !== 'US';
  const translateAsDescribed = withPrefix('discovery.item2Description.asDescribed');
  const title = userOutsideUS ? translateAsDescribed('title') : translateAsDescribed('buyerProtectionTitle');
  const body = userOutsideUS ? translateAsDescribed('body') : translateAsDescribed('buyerProtectionMessage');
  let linkText = userOutsideUS ? translateAsDescribed('linkText') : translateAsDescribed('buyerProtectionLinkText');
  linkText = refreshed ? translateAsDescribed('learnMoreText') : linkText;

  return (
    <div className="scaling-mt-4">
      <RCAlertBox type={userOutsideUS ? 'warning' : 'info'} small={!refreshed}>
        <h4 className = {classNames(
          'weight-bold mb-2',
          { 'size-120': !refreshed },
        )}>
          {title}
        </h4>
        <p className="mb-0">
          {body}
          <CoreLink
            target="_blank"
            rel="noreferrer"
            className={classNames(
              'ml-space',
              { 'text-link': refreshed },
            )}
            to={URLHelpers.reverbProtectionPath}
          >
            {linkText}
          </CoreLink>
        </p>
      </RCAlertBox>
    </div>
  );
}
